import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VRow,[_c(VCol,{staticClass:"pt-0 px-10",attrs:{"cols":"8"}},[_c('Toolbar',{attrs:{"network":_vm.network}}),_c(VContainer,{staticClass:"px-0 mx-0",staticStyle:{"max-width":"none"}},[_c('router-view',{attrs:{"network":_vm.network,"state":_vm.state}})],1)],1),_c(VCol,{staticClass:"pt-0 pl-0",attrs:{"cols":"4"}},[_c('NetworkInfo',{attrs:{"network":_vm.network,"state":_vm.state}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }